import { useAuth0 } from "@auth0/auth0-react";
import { Box, Typography, Button } from "@mui/material";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import PropTypes from "prop-types";

import SearchBar from "@/components/SearchBar/SearchBar";
import AffiliateSelector from "@/components/sharedComponents/AffiliateSelector";
import { canViewAllAffiliates } from "@/utils/permissionsHandler";

function SubmittedFilesTableFilters({
  searchTerm,
  setSearchTerm,
  selectedLocal,
  dropdownLocals,
  handleSelectedLocalChange,
  handleFilterChange,
  startDate,
  endDate,
  handleEndDateChange,
  handleStartDateChange,
}) {
  const { user } = useAuth0();

  return (
    <Box className="dashboardstyle-header">
      <Typography variant="h5">Submitted Files</Typography>
      <Box className="dashboardstyle-filterContainer">
        {canViewAllAffiliates(user) ? (
          <AffiliateSelector
            affiliates={dropdownLocals}
            onChange={handleSelectedLocalChange}
            selectedLocal={selectedLocal}
          />
        ) : (
          <SearchBar searchTerm={searchTerm} setSearchTerm={setSearchTerm} />
        )}
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <DatePicker
            className="filter-option date-picker-reverse-icon-order"
            label="Start Date"
            value={startDate}
            onChange={handleStartDateChange}
          />
          <DatePicker
            className="filter-option date-picker-reverse-icon-order"
            label="End Date"
            value={endDate}
            onChange={handleEndDateChange}
          />
        </LocalizationProvider>
        <Button
          className="filter-option siteWideBlueText"
          onClick={() => handleFilterChange("clear")}
        >
          reset
        </Button>
      </Box>
    </Box>
  );
}

SubmittedFilesTableFilters.propTypes = {
  searchTerm: PropTypes.string,
  handleInputChange: PropTypes.func,
  handleFilterChange: PropTypes.func,
  startDate: PropTypes.object,
  endDate: PropTypes.object,
  handleEndDateChange: PropTypes.func,
  handleStartDateChang: PropTypes.func,
};

export default SubmittedFilesTableFilters;
